<template>
  <v-menu
    offset-y
    left
    transition="slide-y-transition"
  >
    <template #activator="{ on }">
      <v-btn
        icon
        class="elevation-2"
        v-on="on"
      >
        <v-avatar size="40">
          <v-img :src="UserPicture" />
        </v-avatar>
      </v-btn>
    </template>

    <v-card
      width="350"
      style="padding: 20px; border: solid 1px #d6d0d0;"
    >
      <div style="width: 100%; text-align: center;">
        <div
          style="margin: 0 auto; width: 150px; height: 150px; background: gray; border-radius: 50%;"
          :style="{'background-image': 'url('+UserPicture+')', 'background-size':'cover'}"
        />
        <div class="text-h5">
          {{ user?.name }}
        </div>
        <div class="text-caption">
          {{ user?.email }}
        </div>
        <div class="text-caption">
          {{ userRole() }}
        </div>
        <div class="text-caption">
          ID: {{ user?.id }}
        </div>
      </div>

      <v-divider class="my-1" />
      <v-list-item
        v-for="(item, index) in menu"
        :key="index"
        @click="MyProfileLink(item.link)"
        :exact="item.exact"
        :disabled="item.disabled"
        link
      >
        <v-list-item-icon>
          <v-icon
            small
            :class="{ 'grey--text': item.disabled }"
          >
            {{ item.icon }}
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.key ? $t(item.key) : item.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="my-1" />
      <v-list-item @click="SwitchToFo()">
        <v-list-item-icon>
          <v-icon small>
            mdi-office-building-marker-outline
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Switch to FO</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="my-1" />
      <v-list-item @click="SwitchToFinance()">
        <v-list-item-icon>
          <v-icon small>
            mdi-cash-multiple
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>Switch to Finance</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="my-1" />
      <v-list-item @click="SignOut()">
        <v-list-item-icon>
          <v-icon small>
            mdi-logout-variant
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('menu.logout') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="my-1" />
      <v-list-item @click="FlushSiteData()">
        <v-list-item-icon>
          <v-icon
            small
            class="red--text"
          >
            mdi-broom
          </v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="red--text">
            {{ $t('menu.flushSiteData') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-card>
  </v-menu>
</template>

<script>
import config from "../../configs";
import router from "@/router";
import Auth from "@/services/Auth";
import { mapActions, mapGetters, mapState } from "vuex";
import defaultPicture from "../../assets/account.png";
import configApi from "@/services/Api-config";

export default {
  data() {
    return {
      menu: config.toolbar.user
    };
  },
  computed: {
    ...mapGetters("app", {
      currentRole: "getCurrentRole"
    }),
    ...mapState("app",["user"]),
    UserPicture(){
      let url=this.user?.image_url;
      if (url==null || url==""){
        url=defaultPicture;
      }
      return url;
    }
  },
  async mounted() {
    await this.getMyProfile();
  },
  methods: {
    ...mapActions("app",["getMyProfile"]),
    MyProfileLink(link) {
      if (typeof link == "function"){
        link();
      } else {
        this.$router.push(link);
      }
    },
    userRole() {
      return this.currentRole(this.hotelId);
    },
    SignOut() {
      this.$confirm(
        String(this.$t("m.confirmLogout")),
        String(this.$t("menu.logout")),
        "",
        ()=>{
          Auth.SignOut().then(() => {
            window.location.reload();
          });
        }
      );
    },

    FlushSiteData() {
      this.$confirm(
        String(this.$t("m.confirmFlushSiteData")),
        String(this.$t("menu.flushSiteData")),
        "",
        ()=>{
          // Clear localStorage and sessionStorage
          localStorage.clear();
          sessionStorage.clear();
          // Clear caches
          if ("caches" in window) {
            caches.keys().then(keys => keys.forEach(key => caches.delete(key)));
          }
          // Sign out
          Auth.SignOut().then(() => {
            this.$archNotify({ message: String(this.$t("m.successFlushSiteData")), color: "success" });
            window.location.reload();
          });
        });
    },
    SwitchToFo() {
      window.location.href = configApi.ST_WEB_FO;
    },
    SwitchToFinance() {
      window.location.href = configApi.ST_WEB_Finance;
    },
  }
};
</script>
